"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../../RenderIf"));

var ResizeBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ResizeBar, _Component);

  function ResizeBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ResizeBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ResizeBar).call(this, props));
    _this.state = {
      resizeBarStyle: {
        willChange: 'transform'
      }
    };
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ResizeBar, [{
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      event.preventDefault();
      var onResize = this.props.onResize;
      document.removeEventListener('mouseup', this.handleMouseUp);
      document.removeEventListener('mousemove', this.handleMouseMove);
      onResize(this.newXPosition);
      this.setState({
        resizeBarStyle: {
          willChange: 'transform'
        }
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      event.preventDefault();
      var _this$props = this.props,
          minColumnWidth = _this$props.minColumnWidth,
          maxColumnWidth = _this$props.maxColumnWidth,
          headerWidth = _this$props.headerWidth;
      this.newXPosition = event.clientX - this.startXPosition;
      var minXPosition = minColumnWidth - headerWidth;
      var maxXPosition = maxColumnWidth - headerWidth;

      if (this.newXPosition < minXPosition) {
        this.newXPosition = minXPosition;
      } else if (this.newXPosition > maxXPosition) {
        this.newXPosition = maxXPosition;
      }

      this.setState({
        resizeBarStyle: {
          transform: "translateX(".concat(this.newXPosition, "px)"),
          willChange: 'transform'
        }
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      event.preventDefault();
      this.newXPosition = 0;
      this.startXPosition = event.clientX;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          minColumnWidth = _this$props2.minColumnWidth,
          maxColumnWidth = _this$props2.maxColumnWidth,
          isResizable = _this$props2.isResizable,
          ariaLabel = _this$props2.ariaLabel;
      var resizeBarStyle = this.state.resizeBarStyle;
      return _react["default"].createElement(_RenderIf["default"], {
        isTrue: isResizable
      }, _react["default"].createElement("span", {
        className: "rainbow-table_header-resize-bar",
        role: "presentation",
        draggable: true,
        onMouseDown: this.handleMouseDown,
        style: resizeBarStyle
      }, _react["default"].createElement("input", {
        type: "range",
        min: minColumnWidth,
        max: maxColumnWidth,
        "aria-label": ariaLabel,
        tabIndex: -1,
        className: "rainbow-table_header-resize-bar_input"
      }), _react["default"].createElement("span", {
        className: "rainbow-table_header-resize-bar_table-guideline",
        role: "presentation",
        draggable: true,
        onMouseDown: this.handleMouseDown
      })));
    }
  }]);
  return ResizeBar;
}(_react.Component);

exports["default"] = ResizeBar;
ResizeBar.propTypes = {
  minColumnWidth: _propTypes["default"].number,
  maxColumnWidth: _propTypes["default"].number,
  isResizable: _propTypes["default"].bool.isRequired,
  ariaLabel: _propTypes["default"].string,
  onResize: _propTypes["default"].func,
  headerWidth: _propTypes["default"].number.isRequired
};
ResizeBar.defaultProps = {
  minColumnWidth: undefined,
  maxColumnWidth: undefined,
  ariaLabel: undefined,
  onResize: function onResize() {}
};